// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"2b03aaf5","551":"22725db1","793":"428ff3ec","906":"a73be28a"}[chunkId] + ".chunk.css";
};